import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { VarietyPropertiesTGAResponse, VarietyPropertiesTGAUpsertRequest, ApiResponse, CropVariety } from '../models/tga-varieties.model';

@Injectable({
  providedIn: 'root',
})
export class TGAVarietiesService {
  private readonly env = inject<AgrEnvironment>(EnvironmentInjector);
  protected readonly http = inject(HttpClient);
  protected baseUrl = this.env.APIM_BASE_URL + '/arable-advice-service';

  getVarietyPropertiesTGA(): Observable<VarietyPropertiesTGAResponse[]> {
    return this.http.get<VarietyPropertiesTGAResponse[]>(`${this.baseUrl}/variety-properties-tga`);
  }

  getVarietyPropertiesTGAById(varietyPropertiesId: number): Observable<VarietyPropertiesTGAResponse> {
    return this.http.get<VarietyPropertiesTGAResponse>(`${this.baseUrl}/variety-properties-tga/${varietyPropertiesId}`);
  }

  upsertVarietyPropertiesTGA(varietyProperties: VarietyPropertiesTGAUpsertRequest): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.baseUrl}/variety-properties-tga`, varietyProperties);
  }

  deleteVarietyPropertiesTGA(id: number): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`${this.baseUrl}/variety-properties-tga/${id}`);
  }

  getAllCropVarieties(): Observable<CropVariety[]> {
    return this.http.get<CropVariety[]>(`${this.baseUrl}/crop-variety`);
  }
}
